import * as React from 'react';
import { IMask, IMaskInput } from 'react-imask';

interface TimeMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  twelveHourFormat: Boolean;
}

export const TimeMask = React.forwardRef<HTMLElement, TimeMaskProps>(function PhoneNumberMask(props, ref) {
  const { twelveHourFormat = true, onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      mask="hh:mm"
      blocks={{
        hh: {
          mask: IMask.MaskedRange,
          from: twelveHourFormat ? 1 : 0,
          to: twelveHourFormat ? 12 : 23,
          autofix: 'pad',
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
          autofix: 'pad',
        },
      }}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});
